import { Suspense, useEffect } from 'react'
import { useRoutes, useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { routes } from './routes'

function LoadingScreen() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-purple-500 flex items-center justify-center shadow-lg shadow-primary/30 animate-pulse">
          <span className="text-2xl font-bold text-white tracking-tight">IM</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:-0.3s]" />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce [animation-delay:-0.15s]" />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce" />
        </div>
      </div>
    </div>
  )
}

export default function App() {
  const { isAuthenticated, isLoading, initialize } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    initialize()
  }, [initialize])

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated && location.pathname !== '/login') {
        navigate('/login', { replace: true })
      } else if (isAuthenticated && location.pathname === '/login') {
        navigate('/', { replace: true })
      }
    }
  }, [isAuthenticated, isLoading, location.pathname, navigate])

  const element = useRoutes(routes)

  if (isLoading) {
    return <LoadingScreen />
  }

  return <Suspense fallback={<LoadingScreen />}>{element}</Suspense>
}
